import type { AuthDto } from '@mathflat/domain/@entities/Auth'
import type { Student } from 'src/dto'

import authApi from '@/api/auth.api'

import { makeAdapter } from './Adapter'
import type Controller from './Controller'

/***
 * @see authApi
 ***/
class AuthController implements Controller {
  adapter = makeAdapter({
    from(data) {
      return data
    },
    to(data: req.Login) {
      return {
        id: data.id.trim(),
        password: data.password.trim(),
      }
    },
  })

  async resetMyPassword(password: req.ResetPassword) {
    await authApi.postPassword(password)
  }

  async findPasswordFirstStep(params: req.FindPasswordFirstStep) {
    await authApi.postResetToken(params)
  }

  async findPasswordSecondStep(params: req.FindPasswordSecondStep) {
    await authApi.getCheckResetToken(params)
  }
  async findPasswordThirdStep(params: req.FindPasswordThirdStep) {
    await authApi.patchCheckResetToken(params)
  }
  async resetStudentPassword(studentId: Student['id']) {
    await authApi.patchPassword({
      type: 'STUDENT',
      newPassword: '123456',
      newPasswordCheck: '123456',
      relationId: studentId,
    })
  }
  async resetParentPassword(parentId: Student['loginId']) {
    await authApi.patchPassword({
      type: 'PARENT',
      newPassword: '123456',
      newPasswordCheck: '123456',
      relationId: parentId,
    })
  }

  async weizmannLogin(requestDto: AuthDto.WeizmannLoginRequestDto) {
    const { data } = await authApi.postWeizmannLogin(requestDto)
    return data
  }

  async weizmannOauth2Login(requestDto: AuthDto.WeizmannOauth2LoginRequestDto) {
    const { data } = await authApi.postWeizmannOauth2Login(requestDto)
    return data
  }
}

export const authController = new AuthController()
